/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import ReactCookieConsent from "react-cookie-consent";

const CookieConsent = () => {
    return (
        <ReactCookieConsent
            location="bottom"
            buttonText="I Understand"
            cookieName="langley_cookie_consent"
            containerClasses="cookie-consent-banner"
            buttonClasses="cookie-consent-button"
            expires={365}
            onAccept={() => {
                console.log("Cookie consent accepted");
            }}
        >
                <div className="cookie-consent-text">
                    This website uses cookies to enhance usability and provide you with a more personal experience. By using this website, you agree to our use of cookies as explained in our{" "}
                    <a
                        href="https://www.tol.ca/en/connect/egovernment-privacy-policy.aspx"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="cookie-consent-link"
                    >
                        Privacy Policy
                    </a>.
                </div>
        </ReactCookieConsent>
    );
};

export { CookieConsent };
